module.exports = __webpack_public_path__ + "static/media/frog(10).23d898ac.PNG";